import { render, staticRenderFns } from "./DeviceAndPlaylistLayout.vue?vue&type=template&id=7ffc4e02&"
import script from "./DeviceAndPlaylistLayout.vue?vue&type=script&lang=js&"
export * from "./DeviceAndPlaylistLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QTooltip,QInput,QIcon,QTabs,QTab,QDialog,QCardSection,QCardActions,QSelect,QForm,QPopupProxy,QColor,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QCard,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QTooltip,QInput,QIcon,QTabs,QTab,QDialog,QCardSection,QCardActions,QSelect,QForm,QPopupProxy,QColor})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
